import { audioService } from "@/core/audio/audioService";

/**
 * Special number configuration.
 * value  → { animationKey, nickname, playSound, durationMs }
 *
 * durationMs is the total length of the visual effect (2000–3000 ms
 * per the user requirement to keep the game pace snappy).
 */

export const SPECIAL_NUMBERS = {
  7: {
    animationKey: "neon-pulse",
    nickname: "Lucky Seven",
    playSound: () => audioService.playSpecial7(),
    durationMs: 2200,
  },
  13: {
    animationKey: "shadow-thirteen",
    nickname: "Unlucky Thirteen",
    playSound: () => audioService.playSpecial13(),
    durationMs: 2400,
  },
  21: {
    animationKey: "gold-key",
    nickname: "Key of the Door",
    playSound: () => audioService.playSpecial21(),
    durationMs: 2400,
  },
  22: {
    animationKey: "twin-ducks",
    nickname: "Two Little Ducks",
    playSound: () => audioService.playSpecial22(),
    durationMs: 2200,
  },
  45: {
    animationKey: "halfway-pulse",
    nickname: "Halfway There",
    playSound: () => audioService.playSpecial45(),
    durationMs: 2200,
  },
  69: {
    animationKey: "mirror-flip",
    nickname: "Favourite",
    playSound: () => audioService.playSpecial69(),
    durationMs: 2400,
  },
  77: {
    animationKey: "sunset-strip",
    nickname: "Sunset Strip",
    playSound: () => audioService.playSpecial77(),
    durationMs: 2800,
  },
  88: {
    animationKey: "double-sparkle-bloom",
    nickname: "Two Fat Ladies",
    playSound: () => audioService.playSpecial88(),
    durationMs: 2600,
  },
  90: {
    animationKey: "grand-finale",
    nickname: "Top of the Shop",
    playSound: () => audioService.playSpecial90(),
    durationMs: 3000,
  },
};

export const isSpecialNumber = (v) =>
  v !== null && v !== undefined && !!SPECIAL_NUMBERS[v];

export const specialConfig = (v) => SPECIAL_NUMBERS[v] || null;
